export default __webpack_public_path__ + "static/media/zoom_icon.e38587c0.svg";